/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { DomainMessage } from "../../models/domain-message";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ReadDomainMessages$Params {
  organisation_id: string;
  domain_id: string;
}

export function readDomainMessages(
  http: HttpClient,
  rootUrl: string,
  params: ReadDomainMessages$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<DomainMessage>>> {
  const rb = new RequestBuilder(rootUrl, readDomainMessages.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("domain_id", params.domain_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DomainMessage>>;
    }),
  );
}

readDomainMessages.PATH = "/surfdomeinen/organisations/{organisation_id}/domains/{domain_id}/messages";
